import { render, staticRenderFns } from "./ClinicStaffDashboard.vue?vue&type=template&id=016df952&"
import script from "./ClinicStaffDashboard.vue?vue&type=script&lang=js&"
export * from "./ClinicStaffDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports